import type { TAddress } from "./address";
import type { TApplicationStatus } from "./application";
import type { TPartnerLite } from "./partner";
import type { TScholarshipStatus } from "./scholarship";

export const ProfileType = {
  Student: "Student",
  Guardian: "Guardian",
} as const;

export type TProfile = {
  contactId: string;
  uuid: string;
  address: TAddress;
  age: string;
  applicationStatus: TApplicationStatus;
  canResident: boolean;
  certificatesData: Array<TCertificatesData>;
  createdAt: string;
  dob?: string;
  email: string;
  enrollments: Array<string>;
  euResident: boolean;
  flagged: boolean;
  firstName: string;
  lastName: string;
  orders: Array<string>;
  partner: TPartnerLite;
  partnerTouppAccept: boolean;
  phone: string;
  relatedStudents?: Array<TProfile>;
  scholarshipStatus: TScholarshipStatus;
  tcpaConsent: boolean;
  touppAccept: boolean;
  type: (typeof ProfileType)[keyof typeof ProfileType];
};

type TCertificatesData = {
  inventory: {
    name: string;
    startDate: string;
    _id: string;
  };
  url: string;
};

export type TRelatedProfiles = {
  profileType: string;
  relatedStudents: Array<TProfile>;
};
